module.exports = __webpack_public_path__ + "static/img/3.1306362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/3.jpg
// module id = ZglL
// module chunks = 1